//  登陆
import Home from '@/views/home'

export default [
  {
    path: '/home',
    name: 'home',
    component: Home
  },
];
